#import "../fragments/people-iq-filter-settings-fragment.graphql"

query GetPeopleIqFilterSettings {
    peopleIqFilterSettings {
        ...PeopleIqFilterSettingsFragment
    }
}
